/* eslint-disable no-unused-vars */
import React, { useState, useEffect } from "react";

const useDisplayLobsterQuestions = (currentTrip, effortNr, GearJson) => {
  const [displayTrapsPerEffortQuestion, setDisplayTrapsPerEffortQuestion] =
    useState(true);
  const [displayTrapsInWaterQuestion, setDisplayTrapsInWaterQuestion] =
    useState(true);
  const [displayLinesInWaterQuestion, setDisplayLinesInWaterQuestion] =
    useState(true);
  const [displayTrapsPerStringQuestion, setDisplayTrapsPerStringQuestion] =
    useState(true);
  const [displayAllQuestions, setDisplayAllQuestions] = useState(false);
  const [
    displayStringsHauledPerEffortQuestion,
    setDisplayStringsHauledPerEffortQuestion,
  ] = useState(true);
  const [
    displayAverageSoakTimePerEffortQuestion,
    setDisplayAverageSoakTimePerEffortQuestion,
  ] = useState(true);

  const checkTypeAndGear = (
    currentEffort,
    applicable,
    fieldName,
    currentTrip
  ) => {
    const gearObject =
      applicable &&
      applicable.find((item) => item.CODE === currentEffort.gearcode);
    if (
      gearObject &&
      gearObject.APPLICABLE &&
      gearObject.APPLICABLE.some(
        (obj) =>
          obj.field === fieldName &&
          Array.isArray(obj.report_types) &&
          (obj.report_types.includes(Number(currentTrip.report_type)) ||
            obj.report_types.includes(Number(currentTrip.reportType)))
      )
    ) {
      return true;
    }
    return false;
  };

  useEffect(() => {
    let selectedImage = currentTrip;
    if (currentTrip && currentTrip.images) {
      selectedImage = currentTrip.images[effortNr];
    }

    const linesInWater = checkTypeAndGear(
      selectedImage,
      GearJson,
      "lines_in_water_per_area",
      currentTrip
    );
    setDisplayLinesInWaterQuestion(linesInWater);

    const trapsInWater = checkTypeAndGear(
      selectedImage,
      GearJson,
      "traps_in_water_per_area",
      currentTrip
    );
    setDisplayTrapsInWaterQuestion(trapsInWater);

    const trapsPerString = checkTypeAndGear(
      selectedImage,
      GearJson,
      "traps_per_string_per_area",
      currentTrip
    );
    setDisplayTrapsPerStringQuestion(trapsPerString);

    const trapsPerEffort = checkTypeAndGear(
      selectedImage,
      GearJson,
      "traps_per_effort",
      currentTrip
    );
    setDisplayTrapsPerEffortQuestion(trapsPerEffort);

    const stringsHauledPerEffort = checkTypeAndGear(
      selectedImage,
      GearJson,
      "strings_hauled_per_effort",
      currentTrip
    );
    setDisplayStringsHauledPerEffortQuestion(stringsHauledPerEffort);

    const averageSoakTimePerEffort = checkTypeAndGear(
      selectedImage,
      GearJson,
      "avg_soak_time_per_effort",
      currentTrip
    );
    setDisplayAverageSoakTimePerEffortQuestion(averageSoakTimePerEffort);
  }, [GearJson, currentTrip, effortNr]);

  return [
    displayTrapsPerEffortQuestion,
    setDisplayTrapsPerEffortQuestion,
    displayTrapsInWaterQuestion,
    setDisplayTrapsInWaterQuestion,
    displayLinesInWaterQuestion,
    setDisplayLinesInWaterQuestion,
    displayTrapsPerStringQuestion,
    setDisplayTrapsPerStringQuestion,
    displayAllQuestions,
    setDisplayAllQuestions,
    checkTypeAndGear,
    displayStringsHauledPerEffortQuestion,
    setDisplayStringsHauledPerEffortQuestion,
    displayAverageSoakTimePerEffortQuestion,
    setDisplayAverageSoakTimePerEffortQuestion,
  ];
};

export default useDisplayLobsterQuestions;
